import { z } from 'zod';
import { MaestraSignalExceptionTypeSchema } from '../../enumerations/MaestraSignalExceptionType';
import { VersionStateSchema } from '../../enumerations/VersionState';
import { UseOrRemoveSchema } from '../../resource-base/baseSchemas';
import { msObject } from '../../resource-base/msObject';
import { MutationValidationResourceSchema } from './mutationValidationResource';
import { PersistableCreationResultSetSchema } from './persistableCreationResultSet';

export const MutationSuccessResponseSchema = msObject({
    type: z.string().nullish(),
    content: MutationValidationResourceSchema.nullable().optional(),
    // TODO: schema
    changed: UseOrRemoveSchema,
    successful: UseOrRemoveSchema,
    validationType: UseOrRemoveSchema,
    httpStatus: UseOrRemoveSchema,
    message: UseOrRemoveSchema,
    path: UseOrRemoveSchema,
    right: UseOrRemoveSchema,
    exceptionType: UseOrRemoveSchema,
    // TODO: do we want to use these?
    fromState: VersionStateSchema.optional(),
    toState: VersionStateSchema.optional(),
});

export const MutationSuccessResponseOfBatchAddSchema = msObject({
    type: z.literal('BATCH_ADD'),
    successful: z.boolean(),
    content: PersistableCreationResultSetSchema.nullable(),
});

export const MutationErrorResponseSchema = MutationSuccessResponseSchema.extend({
    httpStatus: z.string(), // TODO HttpStatus on Spring
    message: z.string().nullable(),
    right: z.string().nullable(),
    exceptionType: MaestraSignalExceptionTypeSchema.nullable(),
});

export type MutationSuccessResponse = z.infer<typeof MutationSuccessResponseSchema>;
export type MutationSuccessResponseOfBatchAdd = z.infer<typeof MutationSuccessResponseOfBatchAddSchema>;
export type MutationErrorResponse = z.infer<typeof MutationErrorResponseSchema>;
